import { render, staticRenderFns } from "./left.vue?vue&type=template&id=6aff522a&scoped=true&"
import script from "./left.vue?vue&type=script&lang=js&"
export * from "./left.vue?vue&type=script&lang=js&"
import style0 from "@/styles/base1.css?vue&type=style&index=0&id=6aff522a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aff522a",
  null
  
)

export default component.exports